var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComfort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 44,
    viewBox: "0 0 80 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_678_1208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0031 9.61047C8.35038 9.61047 0.940308 25.465 0.940308 27.2831V33.8719C0.940308 38.4044 3.88679 42.0844 7.52913 42.0844H72.4707C76.1068 42.0844 79.0596 38.4107 79.0596 33.8719V27.2831C79.0596 25.4713 71.6558 9.61047 40.0031 9.61047V9.61047Z",
    stroke: "#003053",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0596 15.4785C79.0596 13.6667 71.6558 1.09714 40.0031 0.940416C8.51338 0.789958 1.15973 13.4598 0.940308 15.4785",
    stroke: "#DDC77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.940308 15.4784V9.15283C0.940308 4.62027 3.89305 0.940308 7.52913 0.940308H72.4707C76.1131 0.940308 79.0596 4.62027 79.0596 9.15283V15.4784",
    stroke: "#DDC77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4742 30.9129C69.4742 30.9129 61.6817 19.0706 40.8558 19.0706C20.0298 19.0706 10.5259 30.9129 10.5259 30.9129",
    stroke: "#003053",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5259 30.913L12.2123 22.7694",
    stroke: "#003053",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0583 33.0068L10.5259 30.913",
    stroke: "#003053",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4742 30.913L67.7941 22.7694",
    stroke: "#003053",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9418 33.0068L69.4742 30.913",
    stroke: "#003053",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_678_1208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 43.0248,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComfort);
export default __webpack_public_path__ + "static/media/comfort.620cd98bce684023ea8e99eb02aed5bd.svg";
export { ForwardRef as ReactComponent };